<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <VaAvatar :size="32" color="var(--va-primary)">
              <VaIcon name="mso-account_circle" size="24" />
            </VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent class="profile-dropdown__content md:w-60 px-0 py-4 w-full">
        <VaList>
          <VaListItem
            v-for="item in options"
            :key="item.name"
            class="menu-item px-4 text-base cursor-pointer h-8"
            :style="{ '--hover-color': hoverColor }"
            v-bind="resolveLinkAttribute(item)"
            @click="handleClick(item)"
          >
            <VaIcon :name="item.icon" class="pr-1" color="secondary" />
            {{ item.label }}
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { useUserStore } from '../../../../stores/user-store'

const router = useRouter()
const { colors, setHSLAColor } = useColors()
const hoverColor = setHSLAColor(colors.focus, { a: 0.1 })

const handleClick = (item: ProfileListItem) => {
  if (item.name === 'logout') {
    localStorage.clear()
    useUserStore().clearUser()
    router.push({ name: 'login' })
  }
}

type ProfileListItem = {
  name: string
  label: string
  to?: string
  href?: string
  icon: string
}

const options: ProfileListItem[] = [
  {
    name: 'profile',
    label: 'Profile',
    to: 'preferences',
    icon: 'mso-account_circle',
  },
  {
    name: 'logout',
    label: 'Logout',
    to: 'login',
    icon: 'mso-logout',
  },
]

const isShown = ref(false)

const resolveLinkAttribute = (item: ProfileListItem) => {
  return item.to ? { to: { name: item.to } } : item.href ? { href: item.href, target: '_blank' } : {}
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
